import { jsxs as S, jsx as d } from "react/jsx-runtime";
import x from "classnames";
import k, { useMemo as N } from "react";
import "@jetbrains/ring-ui-built/components/global/theme.js";
import "../Theme/ThemeContext.js";
import { useScaleFactor as b } from "../../hooks/useScaleFactor.js";
import "lz-string";
import n from "./Skeleton.module.css.js";
const l = 200, O = k.memo((a) => {
  const {
    circle: e = !1,
    className: c = "",
    innerRadius: m,
    outerRadius: h,
    width: u,
    height: p
  } = a, f = b(), R = (i, w = f) => i != null ? i * w : void 0, [o, t, s, r] = [
    m,
    h,
    u,
    p
  ].map((i) => R(i)), g = e ? {
    borderRadius: "50%",
    height: t ? t * 2 : void 0,
    width: t ? t * 2 : void 0
  } : { height: r, width: s }, v = e ? {
    height: t ? t * 2 : void 0,
    width: t ? t * 2 + l : void 0
  } : { height: r, width: s ? s + l : void 0 }, y = N(() => {
    if (e && o && t) {
      const i = Math.min(o, t);
      return {
        height: i * 2,
        left: t - i + "px",
        top: t - i + "px",
        width: i * 2
      };
    } else
      return { display: "none" };
  }, [e, o, t]);
  return /* @__PURE__ */ S(
    "div",
    {
      className: x(n.container, c),
      style: g,
      "data-test": a["data-test"],
      children: [
        /* @__PURE__ */ d("div", { className: n.background, style: v }),
        /* @__PURE__ */ d("div", { className: n.innerCircle, style: y })
      ]
    }
  );
});
export {
  O as Skeleton
};
